import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import {
  fetchOrderStatusTime,
  fetchOrderStatusTimeDashboard,
} from "@/features/order-status-time/api/order-status-time.api";

export const orderStatusTimeKeys = {
  all: ["order-status-time"] as const,
  list: () => ["order-status-time", "list"] as const,
  dashboard: () => ["order-status-time", "dashboard"] as const,
};

export function orderStatusTimeDashboardQueryOptions() {
  return queryOptions({
    queryKey: orderStatusTimeKeys.dashboard(),
    staleTime: 0,
    refetchOnWindowFocus: true,
    queryFn: fetchOrderStatusTimeDashboard,
  });
}

export function orderStatusTimeInfiniteQueryOptions() {
  return infiniteQueryOptions({
    queryKey: orderStatusTimeKeys.list(),
    staleTime: 0,
    refetchOnWindowFocus: true,
    queryFn: ({ pageParam }) => fetchOrderStatusTime(pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
  });
}
